/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * UserRole
 * User role enumeration with hierarchical permissions (set theory).
 */
export enum UserRole {
  Admin = "admin",
  Moderator = "moderator",
  Standard = "standard",
}

/**
 * TextExtractionProviderType
 * Text extraction provider types.
 */
export enum TextExtractionProviderType {
  AzureDocumentIntelligence = "azure_document_intelligence",
  Local = "local",
}

/**
 * RequestType
 * Types of group requests.
 */
export enum RequestType {
  JoinRequest = "join_request",
  CreateRequest = "create_request",
  InviteRequest = "invite_request",
}

/**
 * RequestStatus
 * Request processing status.
 */
export enum RequestStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
  Cancelled = "cancelled",
  Failed = "failed",
}

/**
 * MemberStatus
 * Membership status.
 */
export enum MemberStatus {
  Active = "active",
  Pending = "pending",
  Suspended = "suspended",
  Expired = "expired",
}

/**
 * MemberRole
 * Roles within a group.
 */
export enum MemberRole {
  Owner = "owner",
  Admin = "admin",
  Member = "member",
  Viewer = "viewer",
}

/**
 * GroupVisibility
 * Group visibility levels.
 */
export enum GroupVisibility {
  Private = "private",
  Organization = "organization",
  Public = "public",
}

/**
 * GroupType
 * Generic group types - organizations can create custom groups with any names.
 */
export enum GroupType {
  Department = "department",
  Project = "project",
  Team = "team",
  Topic = "topic",
  Role = "role",
  Functional = "functional",
  Custom = "custom",
}

/**
 * GroupStatus
 * Group lifecycle status.
 */
export enum GroupStatus {
  Active = "active",
  Inactive = "inactive",
  Archived = "archived",
  Pending = "pending",
}

/**
 * GroupSource
 * Source of the group.
 */
export enum GroupSource {
  Local = "local",
  Entra = "entra",
  Google = "google",
  Okta = "okta",
}

/**
 * FAQStatus
 * Legacy FAQ Status - wird durch ApprovalStatus ersetzt.
 */
export enum FAQStatus {
  Draft = "draft",
  PendingReview = "pending_review",
  Approved = "approved",
  Published = "published",
  Rejected = "rejected",
  Archived = "archived",
}

/**
 * FAQSortBy
 * Sortierungsoptionen für FAQ-Listen.
 */
export enum FAQSortBy {
  Newest = "newest",
  Oldest = "oldest",
  BestRated = "best_rated",
}

/**
 * EmbeddingProviderType
 * Available embedding providers.
 */
export enum EmbeddingProviderType {
  Openai = "openai",
  Azure = "azure",
  Tei = "tei",
  Ollama = "ollama",
  Huggingface = "huggingface",
}

/**
 * DocumentVisibility
 * Document visibility enumeration for hierarchical access control.
 */
export enum DocumentVisibility {
  Private = "private",
  Group = "group",
  Organization = "organization",
  Public = "public",
}

/**
 * DocumentSourceType
 * Quellentyp des Dokuments.
 */
export enum DocumentSourceType {
  Custom = "custom",
  Manual = "manual",
  File = "file",
  Url = "url",
  Sap = "sap",
  Faq = "faq",
  Import = "import",
  Api = "api",
}

/**
 * DocumentSourceStatus
 * Status of document source.
 */
export enum DocumentSourceStatus {
  Active = "active",
  Inactive = "inactive",
  Error = "error",
  Syncing = "syncing",
}

/**
 * DocumentSourceProviderType
 * Available document source provider types.
 */
export enum DocumentSourceProviderType {
  Onedrive = "onedrive",
  Dropbox = "dropbox",
  Nextcloud = "nextcloud",
}

/**
 * DocumentSortBy
 * Sorting options for document lists.
 */
export enum DocumentSortBy {
  Newest = "newest",
  Oldest = "oldest",
  RecentlyUpdated = "recently_updated",
  TitleAsc = "title_asc",
  TitleDesc = "title_desc",
}

/**
 * ChatProviderType
 * Chat provider types.
 */
export enum ChatProviderType {
  Openai = "openai",
  Ollama = "ollama",
  SapAihub = "sap_aihub",
}

/**
 * AuthProviderType
 * Supported authentication provider types.
 */
export enum AuthProviderType {
  Local = "local",
  Entra = "entra",
}

/**
 * ApprovalStatus
 * Approval-Status für Content-Moderation.
 */
export enum ApprovalStatus {
  Draft = "draft",
  PendingReview = "pending_review",
  Approved = "approved",
  Rejected = "rejected",
  Archived = "archived",
}

/**
 * AccessCheckResult
 * Ergebnis einer Zugriffsprüfung.
 */
export interface AccessCheckResult {
  /**
   * Has Access
   * @default false
   */
  has_access?: boolean;
  /** Access Reason */
  access_reason?: string | null;
  /**
   * Is Owner
   * @default false
   */
  is_owner?: boolean;
  /**
   * Has Multiple Owners
   * @default false
   */
  has_multiple_owners?: boolean;
  /**
   * Can Modify Permissions
   * @default false
   */
  can_modify_permissions?: boolean;
}

/**
 * AdminInit
 * Model for admin initialization.
 */
export interface AdminInit {
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Email */
  email: string;
}

/**
 * AuthProviderConfigCreate
 * Model for creating auth provider configurations.
 */
export interface AuthProviderConfigCreate {
  /** Type of authentication provider */
  provider_type: AuthProviderType;
  /**
   * Is Enabled
   * Whether this provider is enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Is Primary
   * Whether this is the primary auth provider
   * @default false
   */
  is_primary?: boolean;
  /**
   * Config
   * Provider-specific configuration
   */
  config?: Record<string, any>;
}

/**
 * AuthProviderConfigUpdate
 * Model for updating auth provider configurations.
 */
export interface AuthProviderConfigUpdate {
  /**
   * Is Enabled
   * Whether this provider is enabled
   */
  is_enabled?: boolean | null;
  /**
   * Is Primary
   * Whether this is the primary auth provider
   */
  is_primary?: boolean | null;
  /**
   * Config
   * Provider-specific configuration
   */
  config?: Record<string, any> | null;
}

/**
 * AuthProviderResponse
 * Response model for auth provider configurations.
 */
export interface AuthProviderResponse {
  /**
   * Id
   * Provider configuration ID
   */
  id: string;
  /** Type of authentication provider */
  provider_type: AuthProviderType;
  /**
   * Is Enabled
   * Whether this provider is enabled
   */
  is_enabled: boolean;
  /**
   * Is Primary
   * Whether this is the primary auth provider
   */
  is_primary: boolean;
  /**
   * Config
   * Provider-specific configuration (secrets masked)
   */
  config: Record<string, any>;
  /**
   * Created At
   * Creation timestamp
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * Last update timestamp
   * @format date-time
   */
  updated_at: string;
}

/** Body_login_for_access_token_api_auth_token_post */
export interface BodyLoginForAccessTokenApiAuthTokenPost {
  /** Grant Type */
  grant_type?: string | null;
  /** Username */
  username: string;
  /**
   * Password
   * @format password
   */
  password: string;
  /**
   * Scope
   * @default ""
   */
  scope?: string;
  /** Client Id */
  client_id?: string | null;
  /**
   * Client Secret
   * @format password
   */
  client_secret?: string | null;
}

/** Body_update_document_file_api_documents__document_id__file_put */
export interface BodyUpdateDocumentFileApiDocumentsDocumentIdFilePut {
  /**
   * File
   * @format binary
   */
  file: File;
  /** Title */
  title?: string | null;
  /** Visibility */
  visibility?: string | null;
  /** Purpose */
  purpose?: string | null;
  /** Tags */
  tags?: string | null;
}

/** Body_update_document_permissions_api_documents__document_id__permissions_put */
export interface BodyUpdateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut {
  /** Visibility */
  visibility?: string | null;
  /** Purpose */
  purpose?: string | null;
  /** Shared With Users */
  shared_with_users?: string | null;
  /** Shared With Groups */
  shared_with_groups?: string | null;
  /** Shared With Roles */
  shared_with_roles?: string | null;
  /** Retention Days */
  retention_days?: number | null;
}

/** Body_upload_document_api_documents_upload_post */
export interface BodyUploadDocumentApiDocumentsUploadPost {
  /**
   * File
   * @format binary
   */
  file: File;
  /** Title */
  title?: string | null;
  /**
   * Category
   * @default "general"
   */
  category?: string | null;
  /** Tags */
  tags?: string | null;
  /**
   * Visibility
   * @default "private"
   */
  visibility?: string | null;
  /**
   * Purpose
   * @default "general"
   */
  purpose?: string | null;
  /** Shared With Users */
  shared_with_users?: string | null;
  /** Shared With Groups */
  shared_with_groups?: string | null;
  /** Shared With Roles */
  shared_with_roles?: string | null;
  /** Retention Days */
  retention_days?: number | null;
  /**
   * Legal Basis
   * @default "legitimate_interest"
   */
  legal_basis?: string | null;
}

/**
 * ChatConfigRequest
 * Request model for chat configuration.
 */
export interface ChatConfigRequest {
  /** Chat provider types. */
  provider_type: ChatProviderType;
  /** Display Name */
  display_name: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /** Model */
  model: string;
  /**
   * Temperature
   * @default 0.7
   */
  temperature?: number;
  /**
   * Max Tokens
   * @default 1000
   */
  max_tokens?: number;
  /**
   * Timeout
   * @default 30
   */
  timeout?: number;
  /**
   * Streaming
   * @default true
   */
  streaming?: boolean;
  /**
   * System Message
   * @default ""
   */
  system_message?: string;
  /** Provider Config */
  provider_config?: Record<string, string | number | boolean | string[]>;
  /**
   * Is Default
   * @default false
   */
  is_default?: boolean;
}

/**
 * ChatConfigResponse
 * Response model for chat configuration.
 */
export interface ChatConfigResponse {
  /**
   * Id
   * @default ""
   */
  id?: string;
  /** Chat provider types. */
  provider_type: ChatProviderType;
  /** Display Name */
  display_name: string;
  /** Description */
  description: string;
  /** Model */
  model: string;
  /** Temperature */
  temperature: number;
  /** Max Tokens */
  max_tokens: number;
  /** Timeout */
  timeout: number;
  /** Streaming */
  streaming: boolean;
  /** System Message */
  system_message: string;
  /** Provider Config */
  provider_config?: Record<string, string | number | boolean | string[]>;
  /** Is Active */
  is_active: boolean;
  /** Is Default */
  is_default: boolean;
  /**
   * Created By
   * @default ""
   */
  created_by?: string;
  /**
   * Updated By
   * @default ""
   */
  updated_by?: string;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/**
 * ChatConfigTest
 * Model for testing chat configuration.
 */
export interface ChatConfigTest {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
  /** Error */
  error?: string | null;
  /** Provider Type */
  provider_type?: string | null;
  /** Test Result */
  test_result?: Record<string, any>;
}

/**
 * ChatHistoryEntry
 * Chat history entry model.
 */
export interface ChatHistoryEntryInput {
  /** Id */
  id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Messages */
  messages: ChatHistoryMessage[];
}

/**
 * ChatHistoryEntry
 * Chat history entry model.
 */
export interface ChatHistoryEntryOutput {
  /** Id */
  id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Messages */
  messages: ChatHistoryMessage[];
}

/**
 * ChatHistoryMessage
 * Individual message in chat history.
 */
export interface ChatHistoryMessage {
  /** Role */
  role: string;
  /** Content */
  content: string;
  /** Sources */
  sources?: ChatSource[] | null;
}

/**
 * ChatMessage
 * Model for chat messages.
 */
export interface ChatMessage {
  /** Role */
  role: string;
  /** Content */
  content: string;
}

/**
 * ChatProviderResponse
 * Response model for chat provider information.
 */
export interface ChatProviderResponse {
  /** Value */
  value: string;
  /** Label */
  label: string;
  /** Description */
  description: string;
  /**
   * Default Model
   * @default ""
   */
  default_model?: string;
  /**
   * Default Models
   * @default []
   */
  default_models?: string[];
  /**
   * Features
   * @default []
   */
  features?: string[];
  /** Required Config */
  required_config: string[];
  /** Optional Config */
  optional_config: string[];
  /**
   * Config Fields
   * @default {}
   */
  config_fields?: Record<string, any>;
  /** Is Active */
  is_active: boolean;
}

/**
 * ChatRequest
 * Model for chat API requests.
 */
export interface ChatRequest {
  /** Messages */
  messages: ChatMessage[];
  /**
   * Stream
   * @default false
   */
  stream?: boolean;
  /**
   * Max Tokens
   * @default 1000
   */
  max_tokens?: number | null;
  /**
   * Temperature
   * @default 0.7
   */
  temperature?: number | null;
}

/**
 * ChatResponse
 * Model for chat API responses.
 */
export interface ChatResponse {
  /** Id */
  id: string;
  /** Created */
  created: number;
  /** Model for chat messages. */
  message: ChatMessage;
  /** Context */
  context?: Record<string, string | number | boolean>[];
  /** Error Code */
  error_code?: string | null;
}

/**
 * ChatSource
 * Source reference in chat messages.
 */
export interface ChatSource {
  /** Document Id */
  document_id: string;
  /** Title */
  title: string;
  /**
   * Url
   * @default ""
   */
  url?: string;
  /**
   * Source Type
   * @default "sap"
   */
  source_type?: string;
  /**
   * Download Url
   * @default ""
   */
  download_url?: string;
  /**
   * Relevance Score
   * @default 0
   */
  relevance_score?: number;
}

/**
 * ConversationDetails
 * Full conversation details including messages.
 */
export interface ConversationDetails {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Message Count */
  message_count: number;
  /** Is Archived */
  is_archived: boolean;
  /** Last Message Preview */
  last_message_preview?: string | null;
  /** Messages */
  messages?: Record<string, any>[];
}

/**
 * ConversationSummary
 * Lightweight conversation info for lists.
 */
export interface ConversationSummary {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Message Count */
  message_count: number;
  /** Is Archived */
  is_archived: boolean;
  /** Last Message Preview */
  last_message_preview?: string | null;
}

/**
 * CreateConversationRequest
 * Request model for creating a new conversation with input validation.
 */
export interface CreateConversationRequest {
  /**
   * Title
   * Conversation title
   * @default "Neuer Chat"
   */
  title?: string | null;
}

/**
 * Document
 * Model for document data.
 */
export interface Document {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /** @default "private" */
  visibility?: DocumentVisibility | null;
  /**
   * Quellentyp des Dokuments.
   * @default "custom"
   */
  source_type?: DocumentSourceType;
  /**
   * Approval-Status für Content-Moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * @default []
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * @default []
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Document Id */
  document_id: string;
  /**
   * Content
   * @default ""
   */
  content?: string;
  /**
   * Status
   * @default "pending"
   */
  status?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Metadata */
  metadata?: Record<string, any>;
  /** File Type */
  file_type?: string | null;
  /** User Id */
  user_id?: string | null;
  /**
   * Processed
   * @default false
   */
  processed?: boolean;
  /** Chunk Count */
  chunk_count?: number | null;
  /** Owner Id */
  owner_id?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Owner Username */
  owner_username?: string | null;
  /** Owner Email */
  owner_email?: string | null;
  /** Owner Full Name */
  owner_full_name?: string | null;
  /**
   * Shared With Users Details
   * @default []
   */
  shared_with_users_details?: Record<string, string>[] | null;
  /**
   * Shared With Groups Details
   * @default []
   */
  shared_with_groups_details?: Record<string, string>[] | null;
}

/**
 * DocumentCreate
 * Model for document creation.
 */
export interface DocumentCreate {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /** @default "private" */
  visibility?: DocumentVisibility | null;
  /**
   * Quellentyp des Dokuments.
   * @default "custom"
   */
  source_type?: DocumentSourceType;
  /**
   * Approval-Status für Content-Moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * User-IDs für spezifisches Sharing
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * Gruppe-IDs für GROUP visibility
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Content */
  content?: string | null;
  /** File Type */
  file_type?: string | null;
}

/**
 * DocumentListResponse
 * Response model for paginated document list.
 */
export interface DocumentListResponse {
  /** Documents */
  documents: Document[];
  /** Total */
  total: number;
}

/**
 * DocumentSourceProviderConfigRequest
 * Request model for admin-level provider configuration.
 */
export interface DocumentSourceProviderConfigRequest {
  /** Available document source provider types. */
  provider_type: DocumentSourceProviderType;
  /** Name */
  name: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /** Description */
  description?: string | null;
  onedrive_config?: OneDriveConfig | null;
  dropbox_config?: DropboxConfig | null;
  nextcloud_config?: NextcloudConfig | null;
}

/**
 * DocumentSourceProviderConfigResponse
 * Response model for admin-level provider configurations.
 */
export interface DocumentSourceProviderConfigResponse {
  /** Id */
  id: string;
  /** Available document source provider types. */
  provider_type: DocumentSourceProviderType;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Enabled */
  enabled: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
}

/**
 * DocumentSourceSyncStatsResponse
 * Response model for sync statistics.
 */
export interface DocumentSourceSyncStatsResponse {
  /** User Connection Id */
  user_connection_id: string;
  /** Total Files */
  total_files: number;
  /** Processed Files */
  processed_files: number;
  /** Pending Files */
  pending_files: number;
  /** Failed Files */
  failed_files: number;
  /** Last Sync Duration */
  last_sync_duration?: number | null;
  /** Average Sync Duration */
  average_sync_duration?: number | null;
  /**
   * Total Size Processed
   * @default 0
   */
  total_size_processed?: number;
}

/**
 * DocumentSourceUserConnectionRequest
 * Request model for user-specific document source connection.
 */
export interface DocumentSourceUserConnectionRequest {
  /** Provider Config Id */
  provider_config_id: string;
  /** Name */
  name: string;
  /**
   * Enabled
   * @default true
   */
  enabled?: boolean;
  /**
   * Sync Interval
   * @default "daily"
   */
  sync_interval?: string;
  /** File Filters */
  file_filters?: string[];
  /**
   * Max File Size
   * @default 52428800
   */
  max_file_size?: number;
  /**
   * Retry Attempts
   * @default 5
   */
  retry_attempts?: number;
  /**
   * Retry Delay
   * @default 60
   */
  retry_delay?: number;
  /**
   * Debounce Seconds
   * @default 10
   */
  debounce_seconds?: number;
  /**
   * Folder Path
   * @default "/"
   */
  folder_path?: string;
  /** Share Url */
  share_url?: string | null;
}

/**
 * DocumentSourceUserConnectionResponse
 * Response model for user-specific document source connections.
 */
export interface DocumentSourceUserConnectionResponse {
  /** Id */
  id: string;
  /** Provider Config Id */
  provider_config_id: string;
  /** Available document source provider types. */
  provider_type: DocumentSourceProviderType;
  /** Provider Name */
  provider_name: string;
  /** User Id */
  user_id: string;
  /** Name */
  name: string;
  /** Enabled */
  enabled: boolean;
  /** Status of document source. */
  status: DocumentSourceStatus;
  /** Sync Interval */
  sync_interval: string;
  /** File Filters */
  file_filters: string[];
  /** Max File Size */
  max_file_size: number;
  /** Retry Attempts */
  retry_attempts: number;
  /** Retry Delay */
  retry_delay: number;
  /** Debounce Seconds */
  debounce_seconds: number;
  /** Folder Path */
  folder_path: string;
  /** Share Url */
  share_url?: string | null;
  /** Last Sync At */
  last_sync_at?: string | null;
  /** Last Successful Sync At */
  last_successful_sync_at?: string | null;
  /**
   * Error Count
   * @default 0
   */
  error_count?: number;
  /** Last Error */
  last_error?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * DropboxConfig
 * Dropbox-specific configuration.
 */
export interface DropboxConfig {
  /** App Key */
  app_key: string;
  /** App Secret */
  app_secret: string;
  /**
   * Redirect Uri
   * @default "http://localhost:8000/auth/dropbox/callback"
   */
  redirect_uri?: string;
}

/**
 * EmailVerification
 * Model for email verification token.
 */
export interface EmailVerification {
  /** Token */
  token: string;
}

/**
 * EmbeddingConfigRequest
 * Request model for embedding configuration.
 */
export interface EmbeddingConfigRequest {
  /** Available embedding providers. */
  provider: EmbeddingProviderType;
  /** Model */
  model: string;
  /** Vector Size */
  vector_size: number;
  /**
   * Batch Size
   * @default 100
   */
  batch_size?: number;
  /**
   * Timeout
   * @default 30
   */
  timeout?: number;
  /**
   * Max Retries
   * @default 3
   */
  max_retries?: number;
  /**
   * Provider Config
   * @default {}
   */
  provider_config?: Record<string, any>;
  /**
   * Display Name
   * @default ""
   */
  display_name?: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
}

/**
 * EmbeddingConfigResponse
 * Response model for embedding configuration.
 */
export interface EmbeddingConfigResponse {
  /**
   * Id
   * @default ""
   */
  id?: string;
  /** Available embedding providers. */
  provider: EmbeddingProviderType;
  /** Model */
  model: string;
  /** Vector Size */
  vector_size: number;
  /** Batch Size */
  batch_size: number;
  /** Timeout */
  timeout: number;
  /** Max Retries */
  max_retries: number;
  /** Provider Config */
  provider_config: Record<string, any>;
  /** Display Name */
  display_name: string;
  /** Description */
  description: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Created By
   * @default ""
   */
  created_by?: string;
  /**
   * Updated By
   * @default ""
   */
  updated_by?: string;
}

/**
 * EmbeddingProviderResponse
 * Response model for embedding provider information.
 */
export interface EmbeddingProviderResponse {
  /** Available embedding providers. */
  value: EmbeddingProviderType;
  /** Label */
  label: string;
  /** Description */
  description: string;
  /** Default Model */
  default_model: string;
  /** Default Vector Size */
  default_vector_size: number;
  /** Required Config */
  required_config: string[];
  /** Optional Config */
  optional_config: string[];
  /** Is Active */
  is_active: boolean;
}

/**
 * EmbeddingTestResponse
 * Response model for embedding configuration test.
 */
export interface EmbeddingTestResponse {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
  /**
   * Error
   * @default ""
   */
  error?: string;
  /**
   * Test Results
   * @default {}
   */
  test_results?: Record<string, any>;
}

/**
 * FAQDocumentCreate
 * Model für FAQ-Erstellung als Document.
 */
export interface FAQDocumentCreate {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /**
   * Document visibility enumeration for hierarchical access control.
   * @default "organization"
   */
  visibility?: DocumentVisibility;
  /**
   * Source Type
   * @default "faq"
   */
  source_type?: string;
  /**
   * Approval-Status für Content-Moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * User-IDs für spezifisches Sharing
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * Gruppe-IDs für GROUP visibility
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Content */
  content?: string | null;
  /**
   * File Type
   * @default "text"
   */
  file_type?: string;
  /**
   * Question
   * Die FAQ Frage
   * @minLength 10
   * @maxLength 500
   */
  question: string;
  /**
   * Answer
   * Die ausführliche Antwort
   * @minLength 20
   */
  answer: string;
  /**
   * Category Tags
   * Kategorie-Tags
   */
  category_tags?: string[];
  /**
   * Language
   * Sprache
   * @default "de"
   */
  language?: string;
}

/**
 * FAQDocumentResponse
 * Response Model für FAQ als Document.
 */
export interface FAQDocumentResponse {
  /** Title */
  title?: string | null;
  /** Url */
  url?: string | null;
  /** @default "private" */
  visibility?: DocumentVisibility | null;
  /**
   * Quellentyp des Dokuments.
   * @default "custom"
   */
  source_type?: DocumentSourceType;
  /**
   * Approval-Status für Content-Moderation.
   * @default "draft"
   */
  approval_status?: ApprovalStatus;
  /**
   * Shared With Users
   * @default []
   */
  shared_with_users?: string[];
  /**
   * Shared With Groups
   * @default []
   */
  shared_with_groups?: string[];
  /**
   * Approved By
   * User-ID des Genehmigers
   */
  approved_by?: string | null;
  /**
   * Approved At
   * Zeitpunkt der Genehmigung
   */
  approved_at?: string | null;
  /**
   * Rejection Reason
   * Grund der Ablehnung
   */
  rejection_reason?: string | null;
  /** Document Id */
  document_id: string;
  /**
   * Content
   * @default ""
   */
  content?: string;
  /**
   * Status
   * @default "pending"
   */
  status?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Metadata */
  metadata?: Record<string, any>;
  /** File Type */
  file_type?: string | null;
  /** User Id */
  user_id?: string | null;
  /**
   * Processed
   * @default false
   */
  processed?: boolean;
  /** Chunk Count */
  chunk_count?: number | null;
  /** Owner Id */
  owner_id?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Owner Username */
  owner_username?: string | null;
  /** Owner Email */
  owner_email?: string | null;
  /** Owner Full Name */
  owner_full_name?: string | null;
  /**
   * Shared With Users Details
   * @default []
   */
  shared_with_users_details?: Record<string, string>[] | null;
  /**
   * Shared With Groups Details
   * @default []
   */
  shared_with_groups_details?: Record<string, string>[] | null;
  /**
   * Question
   * @default ""
   */
  question?: string;
  /**
   * Answer
   * @default ""
   */
  answer?: string;
  /**
   * Language
   * @default "de"
   */
  language?: string;
  /**
   * Legacy FAQ Status - wird durch ApprovalStatus ersetzt.
   * @default "draft"
   */
  faq_status?: FAQStatus;
  /**
   * Category Tags
   * @default []
   */
  category_tags?: string[];
  /**
   * View Count
   * @default 0
   */
  view_count?: number;
  /**
   * Helpful Count
   * @default 0
   */
  helpful_count?: number;
  /**
   * Not Helpful Count
   * @default 0
   */
  not_helpful_count?: number;
  /**
   * Allow Rating
   * @default true
   */
  allow_rating?: boolean;
  /**
   * Allow Comments
   * @default false
   */
  allow_comments?: boolean;
  /** User Vote */
  user_vote?: string | null;
}

/**
 * FAQDocumentUpdate
 * Model für FAQ-Updates.
 */
export interface FAQDocumentUpdate {
  /** Question */
  question?: string | null;
  /** Answer */
  answer?: string | null;
  /** Category Tags */
  category_tags?: string[] | null;
  /** Language */
  language?: string | null;
  visibility?: DocumentVisibility | null;
  /** Shared With Users */
  shared_with_users?: string[] | null;
  /** Shared With Groups */
  shared_with_groups?: string[] | null;
}

/**
 * FAQListResponse
 * Response für FAQ Listen.
 */
export interface FAQListResponse {
  /** Faqs */
  faqs: FAQDocumentResponse[];
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Has Next */
  has_next: boolean;
}

/**
 * FAQSearchResponse
 * Response für FAQ Suche.
 */
export interface FAQSearchResponse {
  /** Faqs */
  faqs: FAQDocumentResponse[];
  /** Query */
  query: string;
  /** Total Results */
  total_results: number;
  /** Search Time Ms */
  search_time_ms: number;
}

/**
 * FAQStatsResponse
 * Response für FAQ Statistiken.
 */
export interface FAQStatsResponse {
  /** Total Faqs */
  total_faqs: number;
  /** Pending Review */
  pending_review: number;
  /** Published Faqs */
  published_faqs: number;
  /** Rejected Faqs */
  rejected_faqs: number;
  /** Approved Faqs */
  approved_faqs: number;
  /** Draft Faqs */
  draft_faqs: number;
  /** Archived Faqs */
  archived_faqs: number;
  /** Most Viewed */
  most_viewed: FAQDocumentResponse[];
  /** Most Helpful */
  most_helpful: FAQDocumentResponse[];
  /** Categories */
  categories: Record<string, number>;
  /** Recent Activity */
  recent_activity: Record<string, number>;
}

/**
 * FAQStatusUpdate
 * Model for FAQ status updates.
 */
export interface FAQStatusUpdate {
  /** Legacy FAQ Status - wird durch ApprovalStatus ersetzt. */
  status: FAQStatus;
  /** Rejection Reason */
  rejection_reason?: string | null;
  /**
   * Auto Publish
   * @default true
   */
  auto_publish?: boolean;
}

/**
 * FolderSync
 * Folder sync response model.
 */
export interface FolderSync {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Provider */
  provider: string;
  /** Url */
  url: string;
  /** Description */
  description: string | null;
  /** Folder sync configuration. */
  configuration: FolderSyncConfig;
  /** Status */
  status: string;
  /** Last Sync At */
  last_sync_at: string | null;
  /** Sync Stats */
  sync_stats: Record<string, any>;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * FolderSyncConfig
 * Folder sync configuration.
 */
export interface FolderSyncConfig {
  /**
   * Ssl Verify
   * @default true
   */
  ssl_verify?: boolean;
  /** Selected Files */
  selected_files?: string[] | null;
  /**
   * Sync Subfolders
   * @default true
   */
  sync_subfolders?: boolean;
  /**
   * Default Visibility
   * @default "private"
   */
  default_visibility?: string;
  /**
   * Default Shared With Groups
   * @default []
   */
  default_shared_with_groups?: string[];
  /**
   * Default Shared With Users
   * @default []
   */
  default_shared_with_users?: string[];
  /**
   * Remove Deleted Files
   * @default true
   */
  remove_deleted_files?: boolean;
  /**
   * Update Changed Files
   * @default true
   */
  update_changed_files?: boolean;
  /**
   * Preserve User Changes
   * @default false
   */
  preserve_user_changes?: boolean;
}

/**
 * FolderSyncCreate
 * Create folder sync request.
 */
export interface FolderSyncCreate {
  /** Name */
  name: string;
  /** Provider */
  provider: string;
  /** Url */
  url: string;
  /** Description */
  description?: string | null;
  /** Folder sync configuration. */
  configuration: FolderSyncConfig;
}

/**
 * FolderSyncUpdate
 * Update folder sync request.
 */
export interface FolderSyncUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  configuration?: FolderSyncConfig | null;
  /** Status */
  status?: string | null;
}

/**
 * Group
 * Complete group model with Azure AD compatibility and set-theory based hierarchy support.
 * @example {"admins":["user123","user456"],"created_at":"2025-01-01T10:00:00Z","created_by":"system","description":"Development team for Cpro projects","displayName":"Cpro Entwickler","document_count":23,"external_id":"49913706-109e-4ea4-9e30-9a74c3c3b1a0","groupTypes":[],"id":"49913706-109e-4ea4-9e30-9a74c3c3b1a0","last_synced":"2025-01-24T10:00:00Z","mailEnabled":false,"member_count":8,"owner_id":"user123","securityEnabled":true,"settings":{"allow_document_sharing":true,"require_approval":true,"visibility":"organization"},"source":"entra","status":"active","sync_enabled":true,"tags":["development","cpro","team"],"type":"team"}
 */
export interface Group {
  /**
   * Displayname
   * Group display name (Azure AD compatible)
   * @minLength 1
   * @maxLength 256
   */
  displayName: string;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /**
   * Generic group types - organizations can create custom groups with any names.
   * @default "custom"
   */
  type?: GroupType;
  /**
   * Tags
   * @maxItems 10
   */
  tags?: string[];
  /**
   * Source of the group.
   * @default "local"
   */
  source?: GroupSource;
  /**
   * Grouptypes
   * Azure AD group types
   */
  groupTypes?: string[];
  /**
   * Securityenabled
   * Whether this is a security group
   * @default true
   */
  securityEnabled?: boolean;
  /**
   * Mailenabled
   * Whether this group is mail enabled
   * @default false
   */
  mailEnabled?: boolean;
  /**
   * Id
   * Unique group identifier - Azure AD ID for external groups, slug for local groups
   */
  id: string;
  /**
   * Group lifecycle status.
   * @default "active"
   */
  status?: GroupStatus;
  /** Owner Id */
  owner_id?: string | null;
  /** Admins */
  admins?: string[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated At */
  updated_at?: string | null;
  /** Group configuration settings. */
  settings?: GroupSettings;
  /** Parent Group */
  parent_group?: string | null;
  /**
   * Child Groups
   * Direct child groups
   */
  child_groups?: string[];
  /** Metadata */
  metadata?: Record<string, string | number | boolean>;
  /**
   * External Id
   * External system ID (Azure AD GUID)
   */
  external_id?: string | null;
  /**
   * Sync Enabled
   * Whether this group is synchronized with external source
   * @default false
   */
  sync_enabled?: boolean;
  /**
   * Last Synced
   * Last synchronization timestamp
   */
  last_synced?: string | null;
  /**
   * Document Count
   * @default 0
   */
  document_count?: number;
  /** Last Activity */
  last_activity?: string | null;
  /**
   * Hierarchy Level
   * @default 0
   */
  hierarchy_level?: number;
  /**
   * All Parent Groups
   * All ancestor groups
   */
  all_parent_groups?: string[];
  /**
   * Inherited Permissions
   * Permissions from parent groups
   */
  inherited_permissions?: string[];
}

/**
 * GroupCreate
 * Model for creating a new group.
 */
export interface GroupCreate {
  /**
   * Displayname
   * Group display name (Azure AD compatible)
   * @minLength 1
   * @maxLength 256
   */
  displayName: string;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /**
   * Generic group types - organizations can create custom groups with any names.
   * @default "custom"
   */
  type?: GroupType;
  /**
   * Tags
   * @maxItems 10
   */
  tags?: string[];
  /**
   * Source of the group.
   * @default "local"
   */
  source?: GroupSource;
  /**
   * Grouptypes
   * Azure AD group types
   */
  groupTypes?: string[];
  /**
   * Securityenabled
   * Whether this is a security group
   * @default true
   */
  securityEnabled?: boolean;
  /**
   * Mailenabled
   * Whether this group is mail enabled
   * @default false
   */
  mailEnabled?: boolean;
  /** Group configuration settings. */
  settings?: GroupSettings;
  /** Initial Members */
  initial_members?: string[];
  /** Parent Group */
  parent_group?: string | null;
}

/**
 * GroupListResponse
 * Response for listing groups with pagination.
 */
export interface GroupListResponse {
  /**
   * Groups
   * Groups for current page
   */
  groups: Group[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Summary statistics
   */
  summary?: Record<string, number> | null;
}

/**
 * GroupMemberListResponse
 * Response for listing group members with pagination.
 */
export interface GroupMemberListResponse {
  /**
   * Members
   * Group members for current page
   */
  members: Record<string, any>[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Summary statistics
   */
  summary?: Record<string, number> | null;
}

/**
 * GroupMemberUpdate
 * Model for updating member details.
 */
export interface GroupMemberUpdate {
  role?: MemberRole | null;
  status?: MemberStatus | null;
  permissions?: GroupPermissions | null;
  /** Expires At */
  expires_at?: string | null;
  /** Notes */
  notes?: string | null;
}

/**
 * GroupPermissions
 * Member-specific permissions within a group.
 */
export interface GroupPermissions {
  /**
   * Can Share Documents
   * @default true
   */
  can_share_documents?: boolean;
  /**
   * Can Invite Members
   * @default false
   */
  can_invite_members?: boolean;
  /**
   * Can Remove Members
   * @default false
   */
  can_remove_members?: boolean;
  /**
   * Can Edit Group
   * @default false
   */
  can_edit_group?: boolean;
  /**
   * Can Manage Permissions
   * @default false
   */
  can_manage_permissions?: boolean;
}

/**
 * GroupRequest
 * Request related to groups (join, create, etc).
 */
export interface GroupRequest {
  /** Id */
  id?: string | null;
  /** Types of group requests. */
  type: RequestType;
  /** Group Id */
  group_id?: string | null;
  /** User Id */
  user_id: string;
  /**
   * Request processing status.
   * @default "pending"
   */
  status?: RequestStatus;
  /** Reason */
  reason?: string | null;
  /**
   * Requested At
   * @format date-time
   */
  requested_at?: string;
  /** Processed By */
  processed_by?: string | null;
  /** Processed At */
  processed_at?: string | null;
  /** Admin Notes */
  admin_notes?: string | null;
  /**
   * Group Name
   * Requested group name
   */
  group_name?: string | null;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /** Type of group */
  group_type?: GroupType | null;
  /** Group visibility level */
  visibility?: GroupVisibility | null;
  /**
   * Tags
   * Group tags
   */
  tags?: string[] | null;
  /**
   * Justification
   * Reason for requesting group creation
   */
  justification?: string | null;
  /**
   * Approver Ids
   * User IDs of required approvers
   */
  approver_ids?: string[] | null;
  /**
   * Initial Admin Id
   * User ID of the second group admin
   */
  initial_admin_id?: string | null;
  /**
   * Rejection Reason
   * Reason for rejection
   */
  rejection_reason?: string | null;
  /**
   * Locked By
   * User ID who has locked the request for processing
   */
  locked_by?: string | null;
  /**
   * Locked At
   * Timestamp when the request was locked
   */
  locked_at?: string | null;
}

/**
 * GroupRequestApproval
 * Model for approving or rejecting group requests.
 */
export interface GroupRequestApproval {
  /**
   * Admin Notes
   * Admin notes for the approval/rejection
   */
  admin_notes?: string | null;
  /**
   * Rejection Reason
   * Reason for rejection
   */
  rejection_reason?: string | null;
}

/**
 * GroupRequestCreate
 * Model for creating a group creation request (used by standard users to request group creation).
 * @example {"approver_ids":["admin_user_id_123"],"description":"Team for data science collaboration and projects","group_name":"Data Science Team","group_type":"team","initial_admin_id":"team_lead_user_id_456","justification":"We need a dedicated space for the data science team to collaborate on projects and share resources","tags":["data","analytics","science"],"visibility":"organization"}
 */
export interface GroupRequestCreate {
  /**
   * Group Name
   * Requested group name (must be unique)
   * @minLength 3
   * @maxLength 100
   */
  group_name: string;
  /**
   * Description
   * Group description
   */
  description?: string | null;
  /**
   * Justification
   * Reason for requesting group creation
   * @minLength 20
   * @maxLength 500
   */
  justification: string;
  /**
   * Type of group to create
   * @default "custom"
   */
  group_type?: GroupType;
  /**
   * Group visibility level
   * @default "organization"
   */
  visibility?: GroupVisibility;
  /**
   * Approver Ids
   * User IDs of required approvers (must be admin/moderator)
   * @minItems 1
   */
  approver_ids: string[];
  /**
   * Initial Admin Id
   * User ID of the second group admin (requester becomes owner)
   */
  initial_admin_id: string;
  /**
   * Tags
   * Group tags for categorization
   * @maxItems 10
   */
  tags?: string[];
}

/**
 * GroupRequestListResponse
 * Response for listing group requests with pagination.
 */
export interface GroupRequestListResponse {
  /**
   * Requests
   * Group requests for current page
   */
  requests: GroupRequest[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Summary statistics
   */
  summary?: Record<string, number> | null;
}

/**
 * GroupSettings
 * Group configuration settings.
 */
export interface GroupSettings {
  /**
   * Require Approval
   * @default true
   */
  require_approval?: boolean;
  /**
   * Allow Document Sharing
   * @default true
   */
  allow_document_sharing?: boolean;
  /**
   * Members Can Invite
   * @default false
   */
  members_can_invite?: boolean;
  /**
   * Group visibility levels.
   * @default "private"
   */
  visibility?: GroupVisibility;
  /** Max Members */
  max_members?: number | null;
  /** Retention Days */
  retention_days?: number | null;
  /** Auto Accept Domains */
  auto_accept_domains?: string[];
  /** Blocked Domains */
  blocked_domains?: string[];
}

/**
 * GroupUpdate
 * Model for updating group details.
 */
export interface GroupUpdate {
  /** Display Name */
  display_name?: string | null;
  /** Description */
  description?: string | null;
  status?: GroupStatus | null;
  settings?: GroupSettings | null;
  /** Tags */
  tags?: string[] | null;
  /** Metadata */
  metadata?: Record<string, string | number | boolean> | null;
}

/**
 * GroupsPermissionDetail
 * Extended permission detail for groups feature with granular actions.
 */
export interface GroupsPermissionDetail {
  /** Is Visible */
  is_visible: boolean;
  /**
   * Create Request
   * @default false
   */
  create_request?: boolean;
  /**
   * Create Group
   * @default false
   */
  create_group?: boolean;
  /**
   * All Groups
   * @default false
   */
  all_groups?: boolean;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/**
 * MessageResponse
 * Response model for a single message.
 */
export interface MessageResponse {
  /** Id */
  id: string;
  /** Role */
  role: string;
  /** Content */
  content: string;
  /** Sources */
  sources?: Record<string, any>[] | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Message Index */
  message_index: number;
}

/**
 * NextcloudConfig
 * Nextcloud-specific configuration.
 */
export interface NextcloudConfig {
  /** Server Url */
  server_url: string;
  /** Username */
  username: string;
  /** Password */
  password: string;
  /**
   * Webdav Path
   * @default "/remote.php/dav/files/"
   */
  webdav_path?: string;
}

/**
 * OneDriveConfig
 * OneDrive-specific configuration.
 */
export interface OneDriveConfig {
  /** Client Id */
  client_id: string;
  /** Client Secret */
  client_secret: string;
  /** Tenant Id */
  tenant_id: string;
  /**
   * Redirect Uri
   * @default "http://localhost:8000/auth/onedrive/callback"
   */
  redirect_uri?: string;
  /**
   * Scope
   * @default "https://graph.microsoft.com/Files.ReadWrite.All"
   */
  scope?: string;
}

/**
 * OrganizationUpdate
 * Model for organization updates.
 */
export interface OrganizationUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /** Settings */
  settings?: Record<string, any> | null;
  /** Metadata */
  metadata?: Record<string, any> | null;
}

/** PaginatedResponse[ConversationSummary] */
export interface PaginatedResponseConversationSummary {
  /**
   * Items
   * Items for current page
   */
  items: ConversationSummary[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Optional summary statistics
   */
  summary?: Record<string, any> | null;
}

/** PaginatedResponse[MessageResponse] */
export interface PaginatedResponseMessageResponse {
  /**
   * Items
   * Items for current page
   */
  items: MessageResponse[];
  /** Pagination metadata */
  pagination: PaginationInfo;
  /**
   * Summary
   * Optional summary statistics
   */
  summary?: Record<string, any> | null;
}

/**
 * PaginationInfo
 * Pagination metadata for list responses.
 * Provides comprehensive information about pagination state.
 */
export interface PaginationInfo {
  /**
   * Total
   * Total number of items across all pages
   * @min 0
   */
  total: number;
  /**
   * Page
   * Current page number (1-indexed)
   * @min 1
   */
  page: number;
  /**
   * Page Size
   * Number of items per page
   * @min 1
   * @max 100
   */
  page_size: number;
  /**
   * Has Next
   * Whether there is a next page
   */
  has_next: boolean;
  /**
   * Has Previous
   * Whether there is a previous page
   */
  has_previous: boolean;
  /**
   * Total Pages
   * Total number of pages
   * @min 0
   */
  total_pages: number;
}

/**
 * PasswordChangeRequest
 * Model for password change by authenticated user.
 */
export interface PasswordChangeRequest {
  /** Current Password */
  current_password: string;
  /** New Password */
  new_password: string;
}

/**
 * PasswordReset
 * Model for password reset request.
 */
export interface PasswordReset {
  /**
   * Email
   * @format email
   */
  email: string;
}

/**
 * PasswordResetConfirm
 * Model for password reset confirmation.
 */
export interface PasswordResetConfirm {
  /** Token */
  token: string;
  /** New Password */
  new_password: string;
}

/**
 * PermissionDetail
 * Permission detail for a specific feature.
 */
export interface PermissionDetail {
  /** Is Visible */
  is_visible: boolean;
}

/**
 * PublicSharePointLinkRequest
 * Request model for adding a public SharePoint link.
 */
export interface PublicSharePointLinkRequest {
  /** Sharepoint Url */
  sharepoint_url: string;
  /** Name */
  name: string;
  /**
   * Sync Immediately
   * @default true
   */
  sync_immediately?: boolean;
}

/**
 * PublicSharePointSyncRequest
 * Request to sync from a public SharePoint URL.
 */
export interface PublicSharePointSyncRequest {
  /** Sharepoint Url */
  sharepoint_url: string;
  /** Folder Path */
  folder_path?: string | null;
  /**
   * Recursive
   * @default true
   */
  recursive?: boolean;
  /** File Filters */
  file_filters?: any[] | null;
}

/**
 * QdrantCollectionResponse
 * Response model for Qdrant collection operations.
 */
export interface QdrantCollectionResponse {
  /** Status */
  status: string;
  /** Message */
  message: string;
  /** Collection Name */
  collection_name: string;
  /** Points Count */
  points_count: number;
}

/**
 * SMTPConfigRequest
 * SMTP configuration request model.
 */
export interface SMTPConfigRequest {
  /** Smtp Host */
  smtp_host: string;
  /**
   * Smtp Port
   * @default 587
   */
  smtp_port?: number;
  /** Smtp User */
  smtp_user: string;
  /** Smtp Password */
  smtp_password: string;
  /**
   * Smtp From Email
   * @format email
   */
  smtp_from_email: string;
  /**
   * Smtp Use Tls
   * @default true
   */
  smtp_use_tls?: boolean;
  /**
   * Smtp From Name
   * @default "SmartDoc System"
   */
  smtp_from_name?: string;
}

/**
 * SMTPConfigResponse
 * SMTP configuration response model.
 */
export interface SMTPConfigResponse {
  /** Source */
  source: string;
  /** Config */
  config: Record<string, any>;
  /** Error */
  error?: string | null;
}

/**
 * SMTPConfigurationResponse
 * Response model for SMTP configuration.
 */
export interface SMTPConfigurationResponse {
  /** Status */
  status: string;
  /** Host */
  host: string;
  /** Port */
  port: number;
  /** Use Tls */
  use_tls: boolean;
  /** From Email */
  from_email: string;
  /** From Name */
  from_name: string;
}

/**
 * SearchRequest
 * Model for document search requests.
 */
export interface SearchRequest {
  /** Query */
  query: string;
  /** Filter */
  filter?: Record<string, string | number | boolean>;
  /**
   * Limit
   * @default 10
   */
  limit?: number;
}

/**
 * SearchResponse
 * Model for document search responses.
 */
export interface SearchResponse {
  /** Query */
  query: string;
  /** Results */
  results: SearchResult[];
  /** Total */
  total: number;
}

/**
 * SearchResult
 * Model for document search results.
 */
export interface SearchResult {
  /** Document Id */
  document_id: string;
  /** Title */
  title: string;
  /** Url */
  url?: string | null;
  /** Visibility */
  visibility: string;
  /** Relevance Score */
  relevance_score: number;
  /** Content Preview */
  content_preview: string;
}

/**
 * SetPrimaryProviderRequest
 * Request to set primary auth provider.
 */
export interface SetPrimaryProviderRequest {
  /** Provider type to set as primary */
  provider_type: AuthProviderType;
}

/**
 * SettingsUpdate
 * Model for settings updates.
 */
export interface SettingsUpdate {
  /** Branding */
  branding?: Record<string, any> | null;
  /** Features */
  features?: Record<string, any> | null;
  /** Limits */
  limits?: Record<string, any> | null;
  /** Security */
  security?: Record<string, any> | null;
}

/**
 * SharedFolderImportRequest
 * Request to import files from a shared folder.
 */
export interface SharedFolderImportRequest {
  /** Url */
  url: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Selected Files */
  selected_files?: string[] | null;
  /**
   * Visibility
   * @default "private"
   */
  visibility?: string | null;
  /**
   * Shared With Users
   * @default []
   */
  shared_with_users?: string[] | null;
  /**
   * Shared With Groups
   * @default []
   */
  shared_with_groups?: string[] | null;
}

/**
 * SharedFolderValidateRequest
 * Request to validate a shared folder link.
 */
export interface SharedFolderValidateRequest {
  /** Url */
  url: string;
}

/**
 * StatusResponse
 * Standard response for operations that return a simple status.
 */
export interface StatusResponse {
  /**
   * Status
   * @default "success"
   */
  status?: string;
  /** Message */
  message: string;
  /** Details */
  details?: Record<string, string | number | boolean>;
}

/**
 * SystemCleanupResponse
 * Response model for system cleanup operations.
 */
export interface SystemCleanupResponse {
  /** Status */
  status: string;
  /** Message */
  message: string;
  /** Mongodb Deleted */
  mongodb_deleted: number;
  /** Qdrant Deleted */
  qdrant_deleted: number;
  /** S3 Deleted */
  s3_deleted: number;
}

/**
 * SystemStatusResponse
 * Response model for system status.
 */
export interface SystemStatusResponse {
  /** Status */
  status: string;
  /** Version */
  version: string;
  /** Uptime */
  uptime: string;
  /** Database Connected */
  database_connected: boolean;
  /** Redis Connected */
  redis_connected: boolean;
  /** Qdrant Connected */
  qdrant_connected: boolean;
  /** Total Users */
  total_users: number;
  /** Total Documents */
  total_documents: number;
}

/**
 * TestEmailRequest
 * Test email request model.
 */
export interface TestEmailRequest {
  /**
   * Email
   * @format email
   */
  email: string;
}

/**
 * TextExtractionRequest
 * Request model for text extraction configuration.
 */
export interface TextExtractionRequest {
  /** Text extraction provider types. */
  provider: TextExtractionProviderType;
  /**
   * Timeout
   * @default 60
   */
  timeout?: number;
  /**
   * Max Retries
   * @default 3
   */
  max_retries?: number;
  /**
   * Ocr Enabled
   * @default true
   */
  ocr_enabled?: boolean;
  /**
   * Ocr Language
   * @default "en"
   */
  ocr_language?: string;
  /**
   * Extract Tables
   * @default true
   */
  extract_tables?: boolean;
  /**
   * Extract Images
   * @default false
   */
  extract_images?: boolean;
  /**
   * Preserve Layout
   * @default true
   */
  preserve_layout?: boolean;
  /**
   * Provider Config
   * @default {}
   */
  provider_config?: Record<string, any>;
  /**
   * Display Name
   * @default ""
   */
  display_name?: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
}

/**
 * TextExtractionResponse
 * Response model for text extraction configuration.
 */
export interface TextExtractionResponse {
  /** Text extraction provider types. */
  provider: TextExtractionProviderType;
  /** Timeout */
  timeout: number;
  /** Max Retries */
  max_retries: number;
  /** Ocr Enabled */
  ocr_enabled: boolean;
  /** Ocr Language */
  ocr_language: string;
  /** Extract Tables */
  extract_tables: boolean;
  /** Extract Images */
  extract_images: boolean;
  /** Preserve Layout */
  preserve_layout: boolean;
  /** Provider Config */
  provider_config: Record<string, any>;
  /** Display Name */
  display_name: string;
  /** Description */
  description: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Created By */
  created_by: string;
}

/**
 * UpdateConversationRequest
 * Request model for updating conversation with validation.
 */
export interface UpdateConversationRequest {
  /**
   * Title
   * New conversation title
   */
  title?: string | null;
  /**
   * Is Archived
   * Archive status
   */
  is_archived?: boolean | null;
}

/**
 * User
 * Model for user data response.
 */
export interface User {
  /** Username */
  username: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Full Name */
  full_name?: string | null;
  /**
   * User role enumeration with hierarchical permissions (set theory).
   * @default "standard"
   */
  role?: UserRole;
  /** Id */
  id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Email Verified
   * @default false
   */
  email_verified?: boolean;
  /**
   * Needs Admin Approval
   * @default false
   */
  needs_admin_approval?: boolean;
}

/**
 * UserChatPreference
 * Model for user chat model preference.
 */
export interface UserChatPreference {
  /** Config Id */
  config_id: string;
}

/**
 * UserCreate
 * Model for user creation.
 */
export interface UserCreate {
  /** Username */
  username: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Full Name */
  full_name?: string | null;
  /**
   * User role enumeration with hierarchical permissions (set theory).
   * @default "standard"
   */
  role?: UserRole;
  /** Password */
  password: string;
}

/**
 * UserPermissions
 * User permissions mapping for frontend.
 */
export interface UserPermissions {
  /** Permission detail for a specific feature. */
  dashboard: PermissionDetail;
  /** Permission detail for a specific feature. */
  chat: PermissionDetail;
  /** Permission detail for a specific feature. */
  documents: PermissionDetail;
  /** Permission detail for a specific feature. */
  settings: PermissionDetail;
  /** Permission detail for a specific feature. */
  my_groups: PermissionDetail;
  /** Permission detail for a specific feature. */
  public_groups: PermissionDetail;
  /** Permission detail for a specific feature. */
  users: PermissionDetail;
  /** Extended permission detail for groups feature with granular actions. */
  groups: GroupsPermissionDetail;
  /** Permission detail for a specific feature. */
  chat_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  embedding_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  text_extraction_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  document_sources: PermissionDetail;
  /** Permission detail for a specific feature. */
  smtp_config: PermissionDetail;
  /** Permission detail for a specific feature. */
  system_management: PermissionDetail;
}

/**
 * UserRegister
 * Model for user self-registration.
 */
export interface UserRegister {
  /** Username */
  username: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Password */
  password: string;
  /** Full Name */
  full_name?: string | null;
}

/**
 * UserUpdate
 * Model for user updates.
 */
export interface UserUpdate {
  /** Email */
  email?: string | null;
  /** Full Name */
  full_name?: string | null;
  role?: UserRole | null;
  /** Password */
  password?: string | null;
  /** Active */
  active?: boolean | null;
  /** Email Verified */
  email_verified?: boolean | null;
}

/**
 * ValidateFolderUrlRequest
 * Request to validate a shared folder URL.
 */
export interface ValidateFolderUrlRequest {
  /** Url */
  url: string;
  /** Password */
  password?: string | null;
}

/**
 * ValidateFolderUrlResponse
 * Response from folder URL validation.
 */
export interface ValidateFolderUrlResponse {
  /** Is Valid */
  is_valid: boolean;
  /** Provider */
  provider: string | null;
  /** Folder Info */
  folder_info: Record<string, any> | null;
  /** Files */
  files: Record<string, any>[] | null;
  /** Error Message */
  error_message?: string | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/**
 * WhoAmIResponse
 * Response model for who_am_i endpoint with permissions.
 */
export interface WhoAmIResponse {
  /** User Id */
  user_id: string;
  /** Username */
  username: string;
  /** Email */
  email?: string | null;
  /** Full Name */
  full_name?: string | null;
  /** User role enumeration with hierarchical permissions (set theory). */
  role: UserRole;
  /** User permissions mapping for frontend. */
  permissions: UserPermissions;
  /** Deleted At */
  deleted_at?: string | null;
  /** Deletion Requested By */
  deletion_requested_by?: string | null;
  /**
   * Email Verified
   * @default false
   */
  email_verified?: boolean;
  /**
   * Needs Admin Approval
   * @default false
   */
  needs_admin_approval?: boolean;
}
